import {axios} from '@/utils/axios';

const RESOURCE_NAME = '/accounting/documents/contract-by-cln';

export default {
    get_document_by_id(id) {
        return axios.post(`${RESOURCE_NAME}/get-document-by-id`, {document_id: id})
    },
    create(payload) {
        return axios.post(`${RESOURCE_NAME}/`, payload)
    },
    update(payload) {
        return axios.post(`${RESOURCE_NAME}/update`, payload)
    },
    remove(payload) {
        return axios.post(`${RESOURCE_NAME}/remove`, {"delete_id": payload})
    },
    select_elements() {
        return axios.get(`${RESOURCE_NAME}/select`)
    },
    select(payload) {
        return axios.get(`${RESOURCE_NAME}/select`, payload)
    },
    conducted(payload) {
        return axios.post(`${RESOURCE_NAME}/conducted`, payload)
    },
};